import React from 'react';
import { ButtonText } from './styled';
import { toTitleCase } from 'helpers/strings';

type ShowEnabledButtonProps = {
  buttonLabel: string;
  price?: number;
  crossedOutPrice?: number;
};

export const ShowEnabledButton = ({ buttonLabel, price, crossedOutPrice }: ShowEnabledButtonProps): JSX.Element => {
  return (
    <>
      {price && (
        <>
          {!!crossedOutPrice && <ButtonText className="crossedOutPrice">{`$${crossedOutPrice}`}</ButtonText>}
          <ButtonText>{`$${price} -`}&nbsp;</ButtonText>
        </>
      )}
      <ButtonText>{toTitleCase(buttonLabel)}</ButtonText>
    </>
  );
};
